export function selectedAgentUrl(agentUrl, currentUrl = window.location.href) {
  if (agentUrl) return agentUrl

  const url = new URL(currentUrl)
  url.searchParams.delete("agent_id")
  return `${url.pathname}${url.search}` || "/"
}
